module.exports = __webpack_public_path__ + "static/media/works_of_huihan.918e03a7.png";